"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommandC2D = exports.SetTapTypeAppCommand = exports.SetLocationAliasCommand = exports.ResetCommand = exports.ResetComponent = exports.PurgeCommand = exports.PurgeAction = exports.PurgeComponent = exports.FlushCommand = exports.FlushAction = exports.FlushComponent = exports.CalibrateCommand = exports.CalibrateAction = exports.CalibrateComponent = exports.RestartCommand = exports.RestartComponent = void 0;
const effect_1 = require("effect");
const RoutineSequence = __importStar(require("./routine-sequence"));
const _1 = require(".");
const NAMESPACE = 'Culligan.Device.Class.HydroTapBridge.Command';
exports.RestartComponent = RoutineSequence.Component.pipe(effect_1.Schema.pickLiteral('lcd')).annotations({
    identifier: `${NAMESPACE}.RestartComponent`,
});
exports.RestartCommand = effect_1.Schema.Struct({
    command: RoutineSequence.Id.pipe(effect_1.Schema.pickLiteral('restart')),
    params: effect_1.Schema.Struct({
        component: exports.RestartComponent,
    }),
}).annotations({
    identifier: `${NAMESPACE}.RestartCommand`,
    title: 'Restart Command',
    description: 'Instructs the device to restart the specified component',
});
exports.CalibrateComponent = RoutineSequence.Component.pipe(effect_1.Schema.pickLiteral('boiling', 'light')).annotations({
    identifier: `${NAMESPACE}.CalibrateComponent`,
});
exports.CalibrateAction = RoutineSequence.Action.pipe(effect_1.Schema.pickLiteral('info', 'start', 'exit')).annotations({
    identifier: `${NAMESPACE}.CalibrateAction`,
});
exports.CalibrateCommand = effect_1.Schema.Struct({
    command: RoutineSequence.Id.pipe(effect_1.Schema.pickLiteral('calibrate')),
    params: effect_1.Schema.Struct({
        component: exports.CalibrateComponent,
        action: exports.CalibrateAction,
    }),
}).annotations({
    identifier: `${NAMESPACE}.CalibrateCommand`,
    title: 'Calibrate Command',
    description: 'Instructs the device to start calibrating the specified component',
});
exports.FlushComponent = RoutineSequence.Component.pipe(effect_1.Schema.pickLiteral('tank', 'filter')).annotations({
    identifier: `${NAMESPACE}.FlushComponent`,
});
exports.FlushAction = RoutineSequence.Action.pipe(effect_1.Schema.pickLiteral('info', 'preRun', 'start', 'pause', 'resume', 'finish', 'exit')).annotations({
    identifier: `${NAMESPACE}.FlushAction`,
});
exports.FlushCommand = effect_1.Schema.Struct({
    command: RoutineSequence.Id.pipe(effect_1.Schema.pickLiteral('flush')),
    params: effect_1.Schema.Struct({
        component: exports.FlushComponent,
        action: exports.FlushAction,
    }),
}).annotations({
    identifier: `${NAMESPACE}.FlushCommand`,
    title: 'Flush Command',
    description: 'Instructs the device to start flushing the specified component',
});
exports.PurgeComponent = RoutineSequence.Component.pipe(effect_1.Schema.pickLiteral('co2')).annotations({
    identifier: `${NAMESPACE}.PurgeComponent`,
});
exports.PurgeAction = RoutineSequence.Action.pipe(effect_1.Schema.pickLiteral('info', 'start', 'pause', 'resume', 'finish', 'exit')).annotations({
    identifier: `${NAMESPACE}.PurgeAction`,
});
exports.PurgeCommand = effect_1.Schema.Struct({
    command: RoutineSequence.Id.pipe(effect_1.Schema.pickLiteral('purge')),
    params: effect_1.Schema.Struct({
        component: exports.PurgeComponent,
        action: exports.PurgeAction,
    }),
}).annotations({
    identifier: `${NAMESPACE}.PurgeCommand`,
    title: 'Purge Command',
    description: 'Instructs the device to start purging the specified component',
});
exports.ResetComponent = RoutineSequence.Component.pipe(effect_1.Schema.pickLiteral('filter_counter', 'co2_counter', 'energy_usage', 'co2_sensor_zero_flow')).annotations({
    identifier: `${NAMESPACE}.ResetComponent`,
});
exports.ResetCommand = effect_1.Schema.Struct({
    command: RoutineSequence.Id.pipe(effect_1.Schema.pickLiteral('reset')),
    params: effect_1.Schema.Struct({
        component: exports.ResetComponent,
    }),
}).annotations({
    identifier: `${NAMESPACE}.ResetCommand`,
    title: 'Reset Command',
    description: 'Instructs the device to reset the specified component',
});
exports.SetLocationAliasCommand = effect_1.Schema.Struct({
    command: effect_1.Schema.tag('location_alias.set'),
    params: effect_1.Schema.Struct({
        locationAlias: _1.LocationAlias,
    }),
}).annotations({
    identifier: `${NAMESPACE}.SetLocationAliasCommand`,
    title: 'Set Location Alias',
    description: 'Instructs the device to set its location alias to the given value',
});
exports.SetTapTypeAppCommand = effect_1.Schema.Struct({
    command: effect_1.Schema.tag('tap_type_app.set'),
    params: effect_1.Schema.Struct({
        tapTypeApp: _1.TapTypeApp,
    }),
}).annotations({
    identifier: `${NAMESPACE}.SetTapTypeAppCommand`,
    title: 'Set Tap Application Type',
    description: 'Instructs the device to set the tap application type to the given value',
});
exports.CommandC2D = effect_1.Schema.Union(exports.RestartCommand, exports.CalibrateCommand, exports.FlushCommand, exports.PurgeCommand, exports.ResetCommand, exports.SetLocationAliasCommand, exports.SetTapTypeAppCommand).annotations({ identifier: `${NAMESPACE}.CommandC2D` });
//# sourceMappingURL=command.js.map